import { handleActions } from "redux-actions";
import { compareTypes, getInitialRangeOptions } from "../../constants";
import {
  SET_LOADING,
  SET_CONSTANTS,
  FETCH_MODULE,
  TOGGLE_VIEW,
  FETCH_FILTERS,
  UPDATE_FILTERS,
  TOTAL_REVENUE
} from "../sagas/marketing";
import { getSelectedRangeOptionWithCustom } from "../../../../../utils/date-range-options";

export const initialState = {
  dataTable: {},
  options: {},
  listeners: [],
  isLoading: true,
  material: false,
  isTable: false,
  filters: {
    periodTypes: ["Weekly", "Monthly"],
    compareTypes: compareTypes,
    categories: "",
    filtersDirty: false,
    compareDates: false,
    compareType: {
      id: "previous_year",
      name: "Previous Year"
    }
  }
};

const getActionKey = (key) => key + "/" + TOTAL_REVENUE;

export default handleActions(
  {
    [getActionKey(SET_LOADING)]: (state, { payload }) => ({
      ...state,
      isLoading: payload
    }),
    [getActionKey(SET_CONSTANTS)]: (state, { payload }) => ({ ...state, ...payload }),
    [getActionKey(TOGGLE_VIEW)]: (state, { payload }) => {
      return { ...state, isTable: payload };
    },
    [getActionKey(UPDATE_FILTERS)]: (state, { payload }) => {
      return { ...state, filters: { ...state.filters, filtersDirty: true, ...payload } };
    },
    [getActionKey(FETCH_MODULE)]: (state, { payload: { data_table: dataTable, ...rest } }) => {
      return {
        ...state,
        ...rest,
        filters: { ...state.filters, filtersDirty: false },
        isLoading: false,
        dataTable
      };
    },
    [getActionKey(FETCH_FILTERS)]: (
      state,
      { payload: { start_date: startDate, end_date: endDate, period_type: periodType, ...rest } }
    ) => {
      const categories = rest.classTypes.options.ref_categories;
      // fetch filters always reinitializes all filters with default values
      return {
        ...state,
        isTable: false,
        filters: {
          ...initialState.filters,
          ...rest,
          periodType,
          referralValues: categories,
          referralCategories: categories,
          startDate,
          endDate,
          rangeValue: getSelectedRangeOptionWithCustom({ payload: { startDate, endDate } }), // set as current selected
          // get preexisting range options from getRangeOptions function + Custom Range
          rangeOptions: getInitialRangeOptions(startDate, endDate, state.params.theBeginningOfTime)
        }
      };
    }
  },
  initialState
);
